import {ProductFormActions} from "./_actions"
import {
    get_Only_DeclinableFromTechfields,
    isDroopyGuid,
    isEmpty,
    Languages,
    Roles,
} from "../../utils"
import FormField from "../components/form-field-generator"
import {
    ITranslations,
    ISupplierReference,
    IHandleChangeProps,
    FieldType,
    createOldValue,
    ISupplierDeclinedReference,
} from "../../models"
import {Button, ButtonProps, Divider, Header} from "semantic-ui-react"
import {TechFieldsComponent} from "../components/form-field-containers/com_common-fields"
import {
    DropdownOptionRawValue,
    IFieldState,
} from "./_reducers/_utils/product-form-types"
import {ITreeNode, ITreeState} from "../../utils/tree/interfaces"
import {ITechRawData} from "../../models/bo"
import {ITechFields} from "./_reducers/form-id-state"
import Tree from "../components/tree copy"
import {stringify} from "../../utils/stringifyier"
import {deleteDoublonComplex, deleteDoublons} from "../../utils/doublon-tools"
import React from "react"
import {Multilang} from "../../models/product/multilang-string";

interface IRawDeclination {
    [x: string]: {
        source: ISupplierDeclinedReference
        dropOption: DropdownOptionRawValue
    }[]
}

interface IDeclinationList {
    [dropitId: string]: {
        topRef: ISupplierReference
        declined: ISupplierDeclinedReference
        data: { codeEnum: string; declinable: DropdownOptionRawValue }[]
    }
}

interface IDeclinedFieldsProps {
    isNewProduct: boolean
    actions: ProductFormActions
    techPropNodes: ITreeNode[]
    onFieldLockClick: (event: any, fieldType: FieldType) => void
    handleChangeField: ({
                            code,
                            fieldType,
                            lock,
                            fieldValue,
                            overrideDefaultValue,
                        }: IHandleChangeProps) => void
    formId: string
    techFieldsIsLoading: boolean
    product: ISupplierReference | null
    techFields: ITechFields
    techRawData: ITechRawData[]
    tabIndex: number
    role: Roles
    translations: ITranslations["productForm"]
    handleFieldModifyBtnClick?: (event: any, fieldType: FieldType) => void
    activeLang: Languages
    onFieldLooseFocus: () => void
    previousVersion?: ISupplierReference
    selectedPreviousVersion?: string | null
    isTopRef: IFieldState<boolean>
    activated: IFieldState<boolean>
    ean: IFieldState<string>
    supplierRef: IFieldState<string>
    manufacturerRef: IFieldState<string>
    techNode: IFieldState<ITreeNode>
    techTreeState: IFieldState<ITreeState>
    declinedList?: ISupplierDeclinedReference[] | null
    goToProduct: (droopyId: string, declinedDroopyId?: string) => void
}

const DeclinedFields = ({
                            isNewProduct,
                            activated,
                            isTopRef,
                            product,
                            ean,
                            role,
                            supplierRef,
                            manufacturerRef,
                            techNode,
                            techTreeState,
                            actions,
                            formId,
                            techPropNodes,
                            tabIndex,
                            translations,
                            handleChangeField,
                            goToProduct,
                            onFieldLockClick,
                            handleFieldModifyBtnClick,
                            techFieldsIsLoading,
                            techFields: techFieldList,
                            techRawData,
                            activeLang,
                            onFieldLooseFocus,
                            previousVersion,
                            selectedPreviousVersion = null,
                            declinedList,
                        }: IDeclinedFieldsProps) => {
    const isMarketLeader = role === Roles.MARKET_LEADER

    const handleChangeIsTopRef = (payload: IHandleChangeProps) => {
        actions._onChangeField(formId, {
            code: activated.code,
            lock: activated.lock,
            fieldType: activated.fieldType,
            fieldValue: true,
            errorMessage: "",
            overrideDefaultValue: false,
        })

        actions._onChangeField(formId, {
            code: ean.code,
            lock: ean.lock,
            fieldType: ean.fieldType,
            fieldValue: "",
            errorMessage: "",
            overrideDefaultValue: false,
        })
        actions._onChangeField(formId, {
            code: manufacturerRef.code,
            lock: manufacturerRef.lock,
            fieldType: manufacturerRef.fieldType,
            fieldValue: "",
            errorMessage: "",
            overrideDefaultValue: false,
        })
        actions._onChangeField(formId, {
            code: supplierRef.code,
            lock: supplierRef.lock,
            fieldType: supplierRef.fieldType,
            fieldValue: "",
            errorMessage: "",
            overrideDefaultValue: false,
        })
        handleChangeField(payload)
    }

    // const currentDeclinationLabel =
    //   declinationList.find((x) => x.value === declination.value)?.text ||
    //   translations.declined

    if (!isTopRef.value && !isNewProduct) {
        return <></>
    }

    // GETTING TO KNOW EVERY DECLINABLE CARATECH VALUES USED
    const rawDeclinations = declinedList
        ?.filter((x) => !x.deleted)
        .reduce((acc, x) => {
            x.techFields
                // FILTERING ON ONLY DECLINABLE TECHFIELDS
                .filter((t) =>
                    Object.keys(techFieldList).find(
                        (d) => techFieldList[d].isDeclinable && d === t.codeEnum
                    )
                )
                // COMPILING EVERY DECLINABLE VALUE
                .forEach(
                    (t) =>
                        (acc = {
                            ...acc,
                            [t.codeEnum]: [
                                ...(acc[t.codeEnum] || []),
                                {
                                    source: x,
                                    dropOption: t.valueCode || t.value,
                                },
                            ],
                        })
                )
            return acc
        }, {} as IRawDeclination)

    // CHECK IF EVERY DECLINED HAS ITS OWN DECLINED VALUE
    const declinationList = Object.keys(rawDeclinations || {}).reduce(
        (acc, k) => {
            if (!product) {
                return acc
            }
            const current = rawDeclinations?.[k] || []
            current.forEach((declinedRef) => {
                const droopyId = declinedRef.source.droopyId
                acc[droopyId] = {
                    topRef: product,
                    declined: declinedRef.source,
                    data: [
                        ...(acc[droopyId]?.data || []),
                        {codeEnum: k, declinable: declinedRef.dropOption},
                    ],
                }
            })
            return acc
        },
        {} as IDeclinationList
    )

    const valCartechs = Object.keys(rawDeclinations || {}).reduce((acc, k) => {
        const set = new Set<string>(
            rawDeclinations?.[k]
                .filter((x) => x.dropOption !== "-1" && x.dropOption !== "-")
                .filter(x => !Multilang.String.IsMultilangString(x.dropOption))
                .map((x: any) => stringify(x.dropOption))
        )
        if (set.size > 0) {
            acc = {...acc, [k]: Array.from(set).map((d) => JSON.parse(d))}
        }
        return acc
    }, {} as any)

    return (
        <>
            <h3 className="form-title declination">
                {translations.headDeclinedTitle}
            </h3>
            <div
                style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "flex-start",
                    flexWrap: "wrap",
                }}
            >
                {/* {isNewProduct || isTopRef.value ? ( */}
                <FormField
                    lockable={true}
                    label={translations.isTopRef}
                    // onChange={handleChangeField}
                    isNewProduct={isNewProduct}
                    onChange={handleChangeIsTopRef}
                    data={isTopRef}
                    onFieldLooseFocus={onFieldLooseFocus}
                    onLockClick={onFieldLockClick}
                    disabled={!isNewProduct}
                    style={{
                        textField: {
                            width: "150px",
                            maxWidth: "150px",
                            minWidth: "150px",
                        },
                    }}
                    checkboxProps={{
                        checkboxStyle: "toggle",
                    }}
                />
                <Tree
                    classNames="top-ref"
                    lockable={true}
                    tabIndex={tabIndex++}
                    title={translations.techTreeLabel}
                    // caracFilter={isNewProduct ? undefined : (declination.value as string)}
                    type="tech"
                    isNewProduct={isNewProduct}
                    propNodes={techPropNodes}
                    selected={techNode}
                    previousSelected={createOldValue(
                        selectedPreviousVersion,
                        previousVersion?.techNode,
                        previousVersion
                    )}
                    onChange={handleChangeField}
                    treeState={techTreeState}
                    nodesLoadingState={false}
                    translations={translations}
                    onLockClick={onFieldLockClick}
                    displayed={isTopRef.value}
                    headless={true}
                    purpleButton={!isNewProduct && isMarketLeader}
                    disabled={!isNewProduct && !isMarketLeader}
                />
                {isTopRef.value && (
                    <TechFieldsComponent
                        allDeclinableAreDropdown={true}
                        onlyFields={true}
                        goToProduct={goToProduct}
                        isNewProduct={isNewProduct}
                        valCartechs={valCartechs}
                        allowMultipleSelection={true}
                        allowAddOptions={true}
                        techFields={get_Only_DeclinableFromTechfields(techFieldList)}
                        techRawData={techRawData}
                        previousVersion={previousVersion}
                        selectedPreviousVersion={selectedPreviousVersion}
                        onFieldLockClick={onFieldLockClick}
                        formId={formId}
                        activeLang={activeLang}
                        tabIndex={tabIndex}
                        techFieldsIsLoading={techFieldsIsLoading}
                        lockable={true}
                        handleChangeField={handleChangeField}
                        onFieldLooseFocus={onFieldLooseFocus}
                        handleFieldModifyBtnClick={handleFieldModifyBtnClick}
                        translations={translations}
                    />
                )}
            </div>
            <DeclinedButtons
                goToProduct={goToProduct}
                declinationList={declinationList}
                techRawData={techRawData}
                techFields={techFieldList}
                isTopRef={isTopRef}
            />
            <Divider/>
        </>
    )
}

interface IDeclinedButtonProps {
    goToProduct: (droopyId: string, declinedId?: string) => void
    declinationList: IDeclinationList
    techRawData: ITechRawData[]
    techFields: ITechFields
    isTopRef: IFieldState<boolean>
}

interface ISelectedDeclination extends ITechRawData {
    declinationList: string[]
}

interface IDeclinationPairResult {
    results: {
        codeEnum: string
        declinable: string
    }[]
}

const DeclinedButtons = ({
                             goToProduct,
                             declinationList,
                             techRawData,
                             techFields,
                             isTopRef,
                         }: IDeclinedButtonProps) => {
    const declinations: ISelectedDeclination[] = techRawData
        .filter((x) => x.isDeclinable)
        .map((x) => ({
            ...x,
            declinationList: Array.isArray(techFields[x.codeEnum].value)
                ? techFields[x.codeEnum].value
                : [],
        }))
        .filter((x) => x.declinationList.length > 0)
    let result: IDeclinationPairResult[] = []

    // console.log("DECLINATIONS", declinations)

    const compiledDeclinations = Object.keys(declinationList).reduce((acc, k) => {
        const current = declinationList?.[k]
        if (!current) {
            return acc
        }
        current.data.forEach((d) => {
            const found = acc.find((x) => x.codeEnum === d.codeEnum)
            if (found) {
                found.declinationList = deleteDoublons([
                    ...found.declinationList,
                    d.declinable as string,
                ])
            } else {
                acc = [
                    ...acc,
                    {
                        codeEnum: d.codeEnum,
                        declinationList: [d.declinable as string],
                    },
                ]
            }
        })
        return acc
    }, [] as { codeEnum: string; declinationList: string[] }[])

    declinations.forEach((decli) => {
        const found = compiledDeclinations.find(
            (x) => x.codeEnum === decli.codeEnum
        )
        if (found) {
            found.declinationList = deleteDoublons([
                ...found.declinationList,
                ...decli.declinationList,
            ])
        } else {
            compiledDeclinations.push({
                codeEnum: decli.codeEnum,
                declinationList: decli.declinationList,
            })
        }
    })

    const firstItem = compiledDeclinations.filter(
        (x) => !x.declinationList.every((d) => d === "-1" || d === "-")
    )[0]
    if (firstItem) {
        result = firstItem.declinationList
            .filter((d) => d !== "-1" && d !== "-")
            .map((d) => ({
                results: [{codeEnum: firstItem.codeEnum, declinable: d}],
            }))
        compiledDeclinations.forEach((currentDecli) => {
            if (currentDecli.codeEnum === firstItem.codeEnum) {
                return
            }
            let tmp: IDeclinationPairResult[] = []
            result.forEach((result2) => {
                currentDecli.declinationList.forEach((decli) => {
                    let newResult = [...result2.results]
                    if (decli !== "-1" && decli !== "-") {
                        newResult = [
                            ...newResult,
                            {codeEnum: currentDecli.codeEnum, declinable: decli},
                        ]
                    }
                    tmp = [
                        ...tmp,
                        {
                            results: newResult,
                        },
                    ]
                })
            })
            result = [...tmp]
        })
    }

    result = result.filter(
        (x) =>
            !Object.keys(declinationList).find(
                (k) =>
                    stringify(
                        deleteDoublonComplex(
                            declinationList[k].data.filter(
                                (x) => x.declinable !== "-" && x.declinable !== "-1"
                            ),
                            "codeEnum"
                        )
                    ) === stringify(deleteDoublonComplex(x.results, "codeEnum"))
            )
    )

    // console.log({
    //   techFields,
    //   declinationList,
    //   compiledDeclinations,
    //   techRawData,
    //   declinations,
    //   result,
    // })

    const display = React.useMemo(() => {
        return !!isTopRef.value && (!isEmpty(declinationList) || result.length > 0)
    }, [declinationList, isTopRef.value, result.length])

    return (
        (display && (
            <div className="declinations">
                <h3 className="form-title declination">
                    Déclinaisons
                    {/* {translations.headDeclinedTitle} */}
                </h3>
                <div className="declination-buttons">
                    {Object.keys(declinationList).map((declinedDroopyId) => {
                        const data = declinationList[declinedDroopyId]
                        let buttonLabel: string[] = []
                        techRawData.forEach((t) => {
                            const found = data.data.find((d) => d.codeEnum === t.codeEnum)
                            if (
                                !found ||
                                found.declinable === "-1" ||
                                found.declinable === "-"
                            ) {
                                return
                            }
                            buttonLabel = [
                                ...buttonLabel,
                                (buttonLabel.length > 0 ? " / " : "") +
                                // t.label +
                                // ": " +
                                (t.options.find((e) => e.id === found.declinable)?.label ||
                                    found.declinable + ""),
                            ]
                        })
                        const handleClick = (
                            event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
                            d: ButtonProps
                        ) => {
                            event?.stopPropagation()
                            event?.preventDefault()
                            goToProduct(data.topRef.droopyId, declinedDroopyId)
                        }
                        const content = isDroopyGuid(data.declined.supplierRef) ? (
                            <span className="incomplete">Ref. à renseigner</span>
                        ) : (
                            data.declined.supplierRef
                        )
                        return (
                            <Button
                                key={declinedDroopyId}
                                onClick={handleClick}
                                color="blue"
                                content={buttonLabel}
                                label={{
                                    basic: true,
                                    color: "blue",
                                    pointing: "left",
                                    content,
                                }}
                            />
                        )
                    })}
                    {result
                        .filter(res => res.results.every(x => !Multilang.String.IsMultilangString(x.declinable)))
                        .map((res) => {
                            let buttonLabel: string[] = []
                            techRawData.forEach((t) => {
                                const found = res.results.find((d) => d.codeEnum === t.codeEnum)
                                if (
                                    !found ||
                                    found.declinable === "-1" ||
                                    found.declinable === "-"
                                ) {
                                    return
                                }
                                buttonLabel = [
                                    ...buttonLabel,
                                    (buttonLabel.length > 0 ? " / " : "") +
                                    // t.label +
                                    // ": " +
                                    (t.options.find((e) => e.id + "" === found.declinable)
                                        ?.label || found.declinable + ""),
                                ]
                            })
                            return (
                                <Button
                                    key={stringify(res.results)}
                                    color="black"
                                    content={buttonLabel}
                                    disabled={true}
                                    label={{
                                        basic: true,
                                        color: "grey",
                                        pointing: "left",
                                        content: "Nouvelle déclinaison",
                                    }}
                                />
                            )
                        })}
                </div>
            </div>
        )) || <> </>
    )
}
export default DeclinedFields
